import { connect, type ConnectedProps } from 'react-redux';
import { Modal } from '@adc/parallax-component-library';
import { CLOSE_MODAL } from 'Reducers/modal/types';
import { type RootState } from 'src/reducers';
import i18n from 'Utilities/i18n';

const mapStateToProps = ({ modal }: RootState) => ({
  modal,
});

const connector = connect(mapStateToProps);

type Props = ConnectedProps<typeof connector>;

const _GeneralModal = ({ modal: { isOpen, modalProps }, dispatch }: Props) => {
  const { buttonLayout, details, header, onClose, primaryAction, secondaryAction, testID } =
    modalProps ?? {};

  const defaultPrimaryAction = {
    label: i18n.t('Global.microcopy.common.okCap'),
    onPress: () => {
      onClose?.();
      dispatch({ type: CLOSE_MODAL });
    },
  };

  return (
    <Modal
      testID={testID}
      isOpen={isOpen}
      header={header ?? ''}
      details={details}
      primaryAction={primaryAction ?? defaultPrimaryAction}
      secondaryAction={secondaryAction}
      buttonLayout={buttonLayout}
    />
  );
};

const GeneralModal = connector(_GeneralModal);

export { GeneralModal };
